'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = require('util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class ConsoleLogger {
  debug() {
    console.info(_util2.default.format.apply(_util2.default, arguments));
  }
}
exports.default = ConsoleLogger;
module.exports = exports['default'];
//# sourceMappingURL=ConsoleLogger.js.map



// WEBPACK FOOTER //
// ./src/request-promise-lite/lib/ConsoleLogger.js